"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataShape = exports.localeShape = void 0;
var _propTypes = require("prop-types");
var locale = (0, _propTypes.shape)({
  personData: _propTypes.string.isRequired,
  globalData: _propTypes.string.isRequired,
  libraryBlock: _propTypes.string.isRequired,
  promotionField: _propTypes.string.isRequired,
  lookupField: _propTypes.string.isRequired,
  selectPromotionField: _propTypes.string,
  selectLookupField: _propTypes.string,
  noMatchingPromotionFields: _propTypes.string,
  noMatchingLookupFields: _propTypes.string,
  parameterPlaceholder: _propTypes.string,
  contentParameters: _propTypes.string
});
exports.localeShape = locale;
var data = (0, _propTypes.shape)({
  sourceType: _propTypes.string.isRequired,
  title: _propTypes.string.isRequired,
  areFieldsFetching: _propTypes.bool,
  id: _propTypes.string,
  fields: (0, _propTypes.arrayOf)(_propTypes.string)
});
exports.dataShape = data;